/// <reference path="../templates/App/Consultation/view.html" />
app.controller(
    'ConsultationViewController', ['$scope', '$rootScope', '$sce', '$http', '$stateParams', 'toastr', '$state', 'PlaceService', 'SideBarService', 'HelperService', 'ShareUrlService', '$translate', '$window', 'ExplorerService', 'tmhDynamicLocale', ConsultationViewController]
);


function ConsultationViewController($scope, $rootScope, $sce, $http, $stateParams, toastr, $state, PlaceService, SideBarService, HelperService, ShareUrlService, $translate, $window, ExplorerService, tmhDynamicLocale) {

    var vm = this;
    //load place
    $scope.vm = {};

    $scope.vm.ActiveDescription = {};
    $scope.vm.ActiveDescriptionId = 0;
    $scope.vm.IsCreatingNewDescriptionForBio = false;


    $scope.vm.ActiveDescriptionVm =
    {
        Clients: [{ "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }],
        QualificationList: [{ "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }],
        DescriptionNewPositionText: '1'
    };


    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }

    if ($stateParams.z) {
        $scope.vm.ParamZoneId = $stateParams.z;
    }
    else {
        $scope.vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    $rootScope.CurrentZoneId = $scope.vm.ParamZoneId;

    $translate.use($rootScope.LangForInterface);
    tmhDynamicLocale.set($rootScope.LangForInterface);


    var PlaceGetSingle = PlaceService.getPlace($stateParams.id, $scope.CurrentLang, "", $stateParams.index, $stateParams.sortKey, $stateParams.reverse);
    PlaceGetSingle.then(function (t) {
        var res = t.data;
        $scope.vm = res;
        $scope.params = $stateParams;
        if ($scope.vm.DescriptionList.length > 0) {
            if ($stateParams.descpos) {
                if ($stateParams.descpos > $scope.vm.DescriptionList.length) {
                    $stateParams.descpos = $scope.vm.DescriptionList.length;
                }
                $scope.vm.ActiveDescriptionId = $stateParams.descpos - 1;
            }
            else {
                $scope.vm.ActiveDescriptionId = 0;
            }
            $scope.vm.ActiveDescription = $scope.vm.DescriptionList[$scope.vm.ActiveDescriptionId];
            $scope.GetDescriptionVm();
        }



        $rootScope.ClassificationList = res.ClassificationList;
        $rootScope.DistrictList = res.DistrictList;
        $rootScope.Clients = res.ClientList;
        $rootScope.Comments = res.CommentList;
        $rootScope.SideBar = res.SideBar;
        $rootScope.SideBar.CurrentObjectStatus = res.CurrentPlaceStatus;
        $rootScope.CurrentObjectId = res.CurrentPlace.PlaceId;
        $rootScope.CurrentPageType = $rootScope.EnumLinkType.Place;
        $rootScope.CurrentObjectStatus = res.CurrentPlaceStatus;
        $rootScope.placevm = res;
        $rootScope.SideBar.MesNotes = res.CurrentPlace.MyNotes;

        // <!--[Lam Hong 02-Feb-2021] LVCG-4: Add a new value to the Priority combo with "Null" as option value.-->
        $rootScope.placevm.Priorities = [
            {
                name: $translate.instant("place.creation.prioritynull"),
                id: null
            },
            {
                name: $translate.instant("place.creation.priority0"),
                id: 0
            },
            {
                name: $translate.instant("place.creation.priority1"),
                id: 1
            },
            {
                name: $translate.instant("place.creation.priority2"),
                id: 2
            },
            {
                name: $translate.instant("place.creation.priority3"),
                id: 3
            },
            {
                name: $translate.instant("place.creation.priority4"),
                id: 4
            },
            {
                name: $translate.instant("place.creation.priority5"),
                id: 5
            },
        ];

        $scope.GetAssociatedPlacesOnSideBar();
        $scope.GetAssociatedContactsOnSideBar();
        vm.GetAssociatedFilesOnSideBar();

        ShowGmapsOnSideBar($rootScope.placevm.CurrentPlace.Xwgs84, $rootScope.placevm.CurrentPlace.Ywgs84, $rootScope.sideBarPlaceMap, 'sideBarPlaceMap', false, false);
        $scope.ChangeZoneById($scope.vm.ParamZoneId);

        $scope.vm.StatusList4WorkflowDescriptionObj = angular.copy($rootScope.StatusList4WorkflowDescriptionSt);

    },
        function (e) {
            console.log('Chargement du lieu impossible', e);
        });

    $rootScope.getJobList();

    $scope.OpenInOtherLang = function (lang) {
        $window.location.href = $rootScope.interfaceSubFolder + '/#!/consultation/view?id=' + $stateParams.id + "&lang=" + lang + "&index=" + $stateParams.index + "&sortKey=" + $stateParams.sortKey + "&reverse=" + $stateParams.reverse + "&z=" + $stateParams.z;
    }

    $scope.GetAssociatedPlacesOnSideBar = function () {
        HelperService.GetAssociatedPlacesOnSideBar($stateParams.id, 12, $scope.CurrentLang, true)
            .then(function (data) {
                $rootScope.AssociatedPlaces = data;
            });
    }

    $scope.GetAssociatedContactsOnSideBar = function () {
        HelperService.GetAssociatedContactsOnSideBar($stateParams.id, 12, $scope.CurrentLang, true)
            .then(function (data) {
                $rootScope.SideBar.AssociatedContacts = data;
            });
    }

    $rootScope.SaveAssociatedPlaces = function SaveAssociatedPlaces() {
        promiseAddComment = SideBarService.SaveAssociatedPlaces($stateParams.id, 12, $scope.CurrentLang, $rootScope.AssociatedPlaces);
    };

    vm.GetAssociatedFilesOnSideBar = function () {
        HelperService.GetAssociatedFilesOnSideBar($stateParams.id, $rootScope.EnumLinkType.Place, $scope.CurrentLang)
            .then(function (data) {
                $rootScope.AssociatedFiles = data;
            });
    }

    $rootScope.DownloadAssociatedFile = function (name, $event) {
        $event.stopPropagation();
        var path = name;
        ExplorerService.DownloadAssociatedFile(path, "application/pdf")
            .then(function (response) {
                $scope.selectedItem = null;
            }, function (response) {
                if (response.status > 0) {
                    $scope.errorMsg = response.status + ': ' + response.data;
                }
            }, function (evt) {
                console.log(evt);
                $scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                console.log($scope.progress);
            }
            );

    };

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };
    $scope.UpdatePlace = function UpdatePlace() {

        PlaceService.UpdatePlace($scope.vm, function (response) {

            if (response.success) {

                console.log("ok: ");
                $scope.vm = response;

            } else {
                console.log("error: ");
            }
        });
    };


    $scope.UpdateDescriptionStatus = function () {
        if ($scope.vm.ActiveDescriptionVm.Description != undefined && $scope.vm.ActiveDescriptionVm.Description.DescriptionId != 0) {
            HelperService.UpdateDescriptionStatus($scope.vm.ActiveDescriptionVm.Description.DescriptionId, $scope.CurrentLang, $scope.vm.ActiveDescriptionVm.DescriptionStatus);
        }
    }


    $scope.edit = {};


    //creation nouveau descriptif et navigation ************************************************************************************

    $scope.UpdateDescription = function UpdateDescription() {
        if (!scope.vm.IsCreatingNewDescriptionForBio) {
            PlaceService.UpdateDescription($scope.vm, function (response) {

                if (response.success) {

                    console.log("ok: ");
                    $scope.vm = response;
                } else {
                    console.log("error: ");
                }
            });
        }
        else
            $scope.CreateNewDescriptionForBio();
    };

    $scope.UpdateDescriptionVm = function () {
        if (!$scope.vm.IsCreatingNewDescriptionForBio) {
            HelperService.UpdateDescriptionVm($scope.vm.ActiveDescriptionVm, 12)
                .then(
                    function success(data) {
                        // [Lam Hong 10-Nov-2021] LVCG-41: [BO] Impossible to create a content without a description => to fix the side effect not saving VALIDATED status of the new description.
                        //recharge la page si la position du desc est modifié
                        /*if ($scope.vm.ActiveDescriptionVm.DescriptionCurrentPositionText != $scope.vm.ActiveDescriptionVm.DescriptionNewPositionText) {
                            window.location.reload();
                        }*/
                        window.location.reload();
                    },
                    function error(data) { });
        }
        else {
            $scope.CreateNewDescriptionForBio();
        }
    }

    // [Lam Hong 01-Jul-2021] LVCG-41: [BO] Impossible to create a content without a description
    $scope.InitCreateNewDescriptionIfNotExisting = function InitCreateNewDescriptionIfNotExisting() {
        // alert("$scope.vm.DescriptionList.length = " + $scope.vm.DescriptionList.length);
        if ($scope.vm.DescriptionList.length == 0) {
            $scope.PrepareCreateNewDescriptionForBio();
        }
    }


    $scope.PrepareCreateNewDescriptionForBio = function PrepareCreateNewDescriptionForBio() {
        //add new desc local
        $scope.vm.IsCreatingNewDescriptionForBio = true;
        var newDescLocal = {}//angular.copy($scope.vm.DescriptionList[$scope.vm.ActiveDescriptionId]);
        newDescLocal.DescriptionId = 0;
        newDescLocal.DescriptionTitle = '';
        newDescLocal.Resume = '';
        newDescLocal.Description = '';
        $scope.vm.ActiveDescriptionVm = {};
        $scope.vm.ActiveDescriptionVm.Description = {};
        $scope.vm.ActiveDescriptionVm.Description.DescriptionId = 0;
        $scope.vm.ActiveDescriptionVm.Description.DescriptionTitle = '';
        $scope.vm.ActiveDescriptionVm.Description.Stick = '';
        $scope.vm.ActiveDescriptionVm.Description.Resume = '';
        $scope.vm.ActiveDescriptionVm.Description.Description = '';
        $scope.vm.ActiveDescriptionVm.DescriptionStatus = '';
        $scope.vm.ActiveDescriptionVm.Clients = [];
        $scope.vm.ActiveDescriptionVm.QualificationList = [];
        var lastIndex = $scope.vm.DescriptionList.push(newDescLocal) - 1;
        $scope.vm.ActiveDescriptionId = lastIndex;
    }


    $scope.CreateNewDescriptionForBio = function CreateNewDescriptionForBio() {
        //prepare data supplement
        var descForCreation = {};
        descForCreation.ObjectId = $stateParams.id;
        descForCreation.CurrentLang = $scope.CurrentLang;
        descForCreation.LinkTypeId = 12;
        descForCreation.DescriptionTranslation = $scope.vm.ActiveDescriptionVm.Description;
        descForCreation.DescriptionStatus = $scope.vm.ActiveDescriptionVm.DescriptionStatus;

        PlaceService.CreateNewDescriptionForBio(descForCreation)
            .then(

                function success(data) {
                    $scope.vm.IsCreatingNewDescriptionForBio = false;
                    $scope.vm.DescriptionList[$scope.vm.ActiveDescriptionId] = $rootScope.returnNewDesc;
                    $state.go('app.consultation.view', { id: $stateParams.id, lang: $scope.CurrentLang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z, descpos: $scope.vm.DescriptionList.length });
                },
                function error(data) {
                    $scope.vm.IsCreatingNewDescriptionForBio = false;
                    $scope.vm.DescriptionList[$scope.vm.ActiveDescriptionId] = $rootScope.returnNewDesc;
                    $state.go('app.consultation.view', { id: $stateParams.id, lang: $scope.CurrentLang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z, descpos: $scope.vm.DescriptionList.length });
                });
    }

    $scope.GetDescriptionVm = function GetDescriptionVm() {
        HelperService.GetDescriptionVmWithSort($scope.vm.DescriptionList[$scope.vm.ActiveDescriptionId].DescriptionId, $stateParams.id, 12, 0, $scope.CurrentLang)
            .then(function (desc) {
                $scope.vm.ActiveDescriptionVm = desc;
            });
    }

    //todo
    $scope.PreviousDesc = function PreviousDesc() {
        if ($scope.vm.DescriptionList.length > 0 && $scope.vm.ActiveDescriptionId > 0) {
            $scope.vm.ActiveDescriptionId = $scope.vm.ActiveDescriptionId - 1;
            $state.transitionTo('app.consultation.view', { id: $stateParams.id, lang: $scope.CurrentLang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z, descpos: $scope.vm.ActiveDescriptionId + 1 }, { notify: false });
            $scope.GetDescriptionVm();
        }
    }
    $scope.NextDesc = function NextDesc() {
        if ($scope.vm.DescriptionList.length > 0 && $scope.vm.ActiveDescriptionId < $scope.vm.DescriptionList.length - 1) {
            $scope.vm.ActiveDescriptionId = $scope.vm.ActiveDescriptionId + 1;
            $state.transitionTo('app.consultation.view', { id: $stateParams.id, lang: $scope.CurrentLang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z, descpos: $scope.vm.ActiveDescriptionId + 1 }, { notify: false });
            $scope.GetDescriptionVm();
        }
    }
    $scope.UpdateDescriptionPosition = function UpdateDescriptionPosition() {
        if ($scope.vm.ActiveDescriptionVm.Description != undefined && $scope.vm.ActiveDescriptionVm.Description.DescriptionId != 0) {
            HelperService.UpdateDescriptionPosition($stateParams.id, $scope.vm.ActiveDescriptionVm.Description.DescriptionId, $scope.vm.ActiveDescriptionVm.DescriptionCurrentPositionText, $scope.vm.ActiveDescriptionVm.DescriptionNewPositionText, 12);
        }
    }



    // Fin création nouveau descriptif et navigation ****************************************************************************

    $rootScope.AddComment = function AddComment(CurrentObjectId) {

        promiseAddComment = SideBarService.AddComment($scope.vm.SideBar.CommentEdit, $stateParams.id, $scope.CurrentLang, 12);

        promiseAddComment
            .then(
                function success(data) {
                    $rootScope.Comments = $rootScope.returnNewComments;
                    $rootScope.SideBar.CommentEdit.Comment = '';
                },
                function error(data) {
                }
            );
    };

    $rootScope.SaveContact = function SaveContact(CurrentObjectId) {

        SideBarService.SaveContact($scope.vm.SideBar.Contact, $stateParams.id, $scope.CurrentLang, 12);
    };

    $rootScope.SaveDiffuseur = function SaveDiffuseur() {

        SideBarService.SaveDiffuseur($scope.vm.ClientList, $stateParams.id, $scope.CurrentLang, 12);
    };

    $rootScope.SaveAdressesAssociees = function SaveAdressesAssociees() {

        SideBarService.SaveAdressesAssociees($scope.vm.PlaceList, $stateParams.id, $scope.CurrentLang, 12);
    };

    $rootScope.SaveClassification = function SaveClassification() {

        SideBarService.SaveClassification($scope.vm.ClassificationList, $stateParams.id, $scope.CurrentLang, 12);
    };

    $rootScope.SavePlaceGeo = function SavePlaceGeo() {

        SideBarService.SavePlaceGeo($scope.vm.DistrictList, $stateParams.id, $scope.CurrentLang, 12);
    };

    $rootScope.SavePlaceInfo = function SavePlaceInfo() {

        SideBarService.SavePlaceInfo($scope.vm, $stateParams.id, $scope.CurrentLang, 12);
    };
    $rootScope.SaveContactToObject = function SaveContactToObject() {
        $rootScope.ShowIconLoading();
        SideBarService.SaveContactToObject($stateParams.id, $scope.CurrentLang, 12, $scope.vm.SideBar.AssociatedContacts)
            .then(
                function success(data) {
                    $scope.vm.SideBar.AssociatedContacts = data.data;
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
    };

    $rootScope.LastVerificationEmailSendingDateOfThisPlace = "NA";

    $rootScope.SendOneVerificationEmail = function SendOneVerificationEmail() {
        SideBarService.SendOneVerificationEmail($stateParams.id, $rootScope.EnumLinkType.Place, $scope.vm.SideBar.AssociatedContacts)
            .then(
                function success(data) {
                    console.log(data);
                    toastr.success($translate.instant("EnvoyerEmailVerificationNotification"));
                },
                function error(data) {
                    toastr.error($translate.instant("errorMessage"));
                });
    }

    $rootScope.GetLastSendingTimeOfVerificationEmailOfPlace = function () {
        SideBarService.GetLastSendingTimeOfVerificationEmailOfPlace($stateParams.id)
            .then(
                function success(data) {
                    $rootScope.LastVerificationEmailSendingDateOfThisPlace = data.data;
                },
                function error(data) { });
    }

    $rootScope.GetLastSendingTimeOfVerificationEmailOfPlace();

    $rootScope.SaveAssEdito = function SaveAssEdito() {

        SideBarService.SaveAssEdito($scope.vm.BioList, $stateParams.id, $scope.CurrentLang, 12);
    };

    $rootScope.SaveSP = function SaveSP() {

        SideBarService.SaveSP($scope.SideBar.SP, $stateParams.id, $scope.CurrentLang, 12);
    };

    // SideBar method

    $rootScope.UpdateObjectStatus = function UpdateObjectStatus(status, objectId) {

        SideBarService.UpdateObjectStatus(status, objectId, $scope.CurrentLang, 12);
    };

    $rootScope.refreshHistory = function refreshHistory() {
        var lastelement = $rootScope.SideBar.HistoryList == null ? null : $rootScope.SideBar.HistoryList.shift();
        promiseRefreshHistory = SideBarService.RefreshHistory($rootScope.CurrentObjectId, $stateParams.lang, "Place", (lastelement == null ? 0 : lastelement.ChangeLogId));
        promiseRefreshHistory
            .then(
                function success(data) {
                    $rootScope.SideBar.HistoryList = $rootScope.returnNewHistory.concat($rootScope.SideBar.HistoryList);
                },
                function error(data) {
                });
    };

    $rootScope.shareInfoPratique = function () {
        $rootScope.shareFicheComplete();
    }

    $rootScope.shareFicheComplete = function () {
        ShareUrlService.GenerateSharedUrl($stateParams.id, $rootScope.EnumLinkType.Place, $rootScope.LangForWork)
            .then(function (data) {
                $rootScope.ShareUrlObj = data.data;
            },
                function (data) {
                }
            );
    }
}